import { defineMessages } from 'react-intl';

// Use inverted messages if key pair doesn't exist in retrieve message api
export const invertedMessages: Record<string, string> = {} as const;

// Use below if key is available
export const savicopilotkeys: Record<string, string> = {} as const;

export const l = defineMessages({
  'status.empty': { id: '+Q3dd+', defaultMessage: ' ' },
  'status.enabled': { id: 'V52jNn', defaultMessage: 'Enabled' },
  'status.disabled': { id: 'tthToS', defaultMessage: 'Disabled' },
  'status.active': { id: '3a5wL8', defaultMessage: 'Active' },
  'status.inactive': { id: '6Tps09', defaultMessage: 'Inactive' },
  'status.deleted': { id: 'KQvWvD', defaultMessage: 'Deleted' },
  'label.name': { id: 'HAlOn1', defaultMessage: 'Name' },
  'label.status': { id: 'tzMNF3', defaultMessage: 'Status' },
  'label.owners': { id: 'srCJeL', defaultMessage: 'Owners' },
  'label.tags': { id: '1EYCdR', defaultMessage: 'Tags' },
  'label.service.accounts': {
    id: 'LQG34R',
    defaultMessage: 'Service Accounts',
  },
  'label.applications': { id: 'DqD1yK', defaultMessage: 'Applications' },
  'state.search.failed': {
    id: 'ILxGC+',
    defaultMessage: 'Search failed; please try again',
  },
  'state.loading.dot': { id: 'gjBiyj', defaultMessage: 'Loading...' },
  'state.enter.one.char': {
    id: 'CKHHht',
    defaultMessage: 'Enter at least 1 character to view options.',
  },
  'state.max.owners.reached': {
    id: 'Xlisk4',
    defaultMessage:
      'Max number of owners has been reached. Remove one from the Assigned list before adding more.',
  },
  'state.remove': {
    id: 'G/yZLu',
    defaultMessage: 'Remove',
  },
  'state.add': {
    id: '2/2yg+',
    defaultMessage: 'Add',
  },
  'sort.label.ascending': { id: 'u7djqV', defaultMessage: 'Ascending' },
  'sort.label.descending': { id: 'aleGqT', defaultMessage: 'Descending' },
  'sort.label.name': { id: '8ZDCh9', defaultMessage: 'NAME' },
  'sort.label.status': { id: 'a1fAXn', defaultMessage: 'STATUS' },
  'sort.label.owners': { id: 'D6IVHK', defaultMessage: 'OWNERS' },
  'sort.label.tags': { id: 'yJWdDO', defaultMessage: 'TAGS' },
  'sort.label.service.accounts': {
    id: 'wB74Q7',
    defaultMessage: 'SERVICE ACCOUNTS',
  },
  'rank.1': { id: 'Tf9Oo0', defaultMessage: '1' },
  'rank.2': { id: 'QLJEES', defaultMessage: '2' },
  'rank.3': { id: 'O6+/CI', defaultMessage: '3' },
  'rank.4': { id: 'oyHYtA', defaultMessage: '4' },
  'rank.5': { id: 'Bt8FNx', defaultMessage: '5' },
  'rank.primary.certifier': {
    id: 'fI63Hz',
    defaultMessage: 'Primary Certifier',
  },
  'rank.secondary.certifier': {
    id: 'c1q1wh',
    defaultMessage: 'Secondary Certifier',
  },
  'action.rotate.credentials': {
    id: 'Z0AP0h',
    defaultMessage: 'Rotate Credentials',
  },
  'action.manage.owners': { id: 'CemsDS', defaultMessage: 'Manage Ownership' },
  'action.disable': { id: 'Rw7iI7', defaultMessage: 'Disable' },
  'action.enable': { id: 'TqSTI0', defaultMessage: 'Enable' },
  'action.delete': { id: 'K3r6DQ', defaultMessage: 'Delete' },
});

export type MessageState = keyof typeof l;
